const gql = String.raw;
  
export const Challenge = gql`
query ChallengeBySlugQuery($slug: ID!) {
  challengeBySlug(slug: $slug) {
    
      
    
        id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
    
      
      
            openGraph { 
              id title 
              
              image { 
                id url url2x 
                thumbnails { 
                  id bubble { id url url2x }
      card { id url url2x }
                }
                
              } 
            }
          
    
    banner { id image { id url url2x width height thumbnails { mainBanner { id url url2x } } } }
    description { id text }
    color { id value }
    keyIssues {
    id name slug path __typename 
    color { id value }
    openGraph { 
      description { id text }
      image { url url2x thumbnails { bubble { url url2x } card { url url2x } } } }
    }
    # organisations {
    #   id path slug name __typename _schema { label pluralLabel }
    #   openGraph {
    #     title
    #     image { url url2x }
    #   }
    # }
    # posts {
    #   id path slug name __typename _schema { label pluralLabel }
    #   typeLabel
    #   openGraph {
    #     title
    #     description { plain }
    #     image { url url2x }
    #   }
    # }
    # feedEntries {
    #   id path slug url name __typename _schema { label pluralLabel }
    #   typeLabel
    #   openGraph {
    #     title
    #     description { plain }
    #     image { url url2x }
    #   }
    # }
    # embeds {
    #   imageAssets {
    #     id
    #     slug
    #     image {
    #       id url url2x width height 
    #     }
    #   }
    #   events { 
    #     id path slug name __typename _schema { label pluralLabel }
    #     openGraph {
    #       title description { plain }
    #       image { url url2x }
    #     }
    #   }
    # }
  }
}
`;
